'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/querystring-es3/index.js
 ** module id = 194
 ** module chunks = 0
 **/